import React, { useContext, useState } from "react";

import { baseURL } from "../../config";

import CourseItemsCounter from "../../components/items/CourseItemsCounter";
import CourseDescItem from "../../components/items/CourseDescItem";
import Button from "../../components/ui/Button";
import modal from "../../services/modalServices";
import { useLocation, useNavigate } from "react-router-dom";
import CourseContext from "../../context/CourseContext";

import { isObjectEmpty } from "../../utils/objects";
import auth from "../../services/authServices";
import {
    isPrepaidSystem,
    isSessionReservation,
    isUnassignedSubscription,
} from "../../services/defaultSettings";
import AuthContext from "../../context/AuthContext";
import http from "../../services/httpServices";
import { useLanguage } from "../../context/LanguageContext";

const CourseInfoSection = () => {
    const token = auth.getToken();
    const { language } = useLanguage();
    const content = {
        confirmSubscriptionTitle: {
            en: "Confirmation Message",
            ar: "رسالة تأكيد",
            de: "Bestätigungsnachricht",
        },
        confirmSubscriptionText: {
            en: "Are you sure you want to subscribe to",
            ar: "هل انت متأكد من الاشتراك في",
            de: "Sind Sie sicher, dass Sie sich anmelden möchten für",
        },
        confirmButton: {
            en: "Subscribe",
            ar: "الاشتراك",
            de: "Abonnieren",
        },
        cancelButton: {
            en: "Cancel",
            ar: "إلغاء",
            de: "Abbrechen",
        },
        sessionButton: {
            en: "Book your session",
            ar: "أحجز معاد الجلسة الخاصة بيك",
            de: "Buchen Sie Ihre Sitzung",
        },
        successTitle: {
            en: "Successful Operation",
            ar: "عملية ناجحة",
            de: "Erfolgreicher Vorgang",
        },
        successText: {
            en: "You have successfully subscribed to",
            ar: "تم الاشتراك بـ",
            de: "Sie haben erfolgreich abonniert",
        },
        freeCourse: {
            en: "This course is free!",
            ar: "هذا الكورس مجاني !",
            de: "Dieser Kurs ist kostenlos!",
        },
        alreadySubscribed: {
            en: "You are already subscribed to this course!",
            ar: "انت مشترك بهذا الكورس !",
            de: "Sie sind bereits für diesen Kurs angemeldet!",
        },
        loginRequired: {
            title: {
                en: "Login Required",
                ar: "يجب عليك تسجيل الدخول اولًا",
                de: "Anmeldung erforderlich",
            },
            text: {
                en: "You must log in to purchase this course",
                ar: "يجب عليك تسجيل الدخول لشراء الكورس",
                de: "Sie müssen sich anmelden, um diesen Kurs zu kaufen",
            },
            button: {
                en: "Login",
                ar: "تسجيل الدخول",
                de: "Anmelden",
            },
        },
        subscribeNow: {
            en: "Subscribe Now!",
            ar: "اشترك الآن!",
            de: "Jetzt abonnieren!",
        },
        prepaidBalance: {
            en: "You can subscribe to this course using your prepaid balance",
            ar: "يمكنك الاشتراك في هذا الكورس ضمن رصيدك المسبق الدفع",
            de: "Sie können diesen Kurs mit Ihrem Prepaid-Guthaben abonnieren",
        },
        unassignedBalance: {
            en: "You can subscribe to this course using unassigned subscriptions",
            ar: "يمكنك الاشتراك في هذا الكورس من رصيد الإشتراكات الغير مخصصه",
            de: "Sie können diesen Kurs mit nicht zugewiesenen Abonnements abonnieren",
        },
        totalQuestions: {
            en: "Total Questions",
            ar: "اجمالي الاسئلة",
            de: "Gesamtzahl der Fragen",
        },
    };

    const { course } = useContext(CourseContext);
    let { prepaidCourses, setPrepaidCourses, unassignedSubscriptions, setUnassignedSubscriptions } =
        useContext(AuthContext);

    const [isLoading, setIsLoading] = useState(false);

    const onPrepaidClick = async () => {
        setIsLoading(true);
        modal.message({
            title: content.confirmSubscriptionTitle[language],
            text: `${content.confirmSubscriptionText[language]} ${course.name} ?`,
            icon: "info",
            buttons: {
                confirm: content.confirmButton[language],
                cancel: content.cancelButton[language],
            },
            callback: async (e) => {
                if (e && e !== "cancel") {
                    const token = auth.getToken();
                    const config = auth.getAuthConfig(token);
                    const { data } = await http.post(
                        `/api/user/prepaid_courses`,
                        { course_id: course.id },
                        config
                    );
                    modal.message({
                        title: content.successTitle[language],
                        text: `${content.successText[language]} ${course.name}!`,
                        icon: "success",
                        callback: () => {
                            setPrepaidCourses(prepaidCourses - 1);
                            window.location.reload();
                            // navigate(`/course/${course.id}`);
                        },
                    });
                    setIsLoading(false);
                } else {
                    setIsLoading(false);
                }
            },
        });
    };
    const onAssignCourseClick = async (course_id, name) => {
        setIsLoading(true);
        modal.message({
            title: content.confirmSubscriptionTitle[language],
            text: `${content.confirmSubscriptionText[language]} ${name} ?`,
            icon: "info",
            buttons: {
                confirm: content.confirmButton[language],
                cancel: content.cancelButton[language],
            },
            callback: async (e) => {
                if (e && e !== "cancel") {
                    const token = auth.getToken();
                    const config = auth.getAuthConfig(token);

                    // eslint-disable-next-line no-unused-vars
                    const { data } = await http.post(
                        `/api/user/assign_unassigned_subscription`,
                        { course_id },
                        config
                    );
                    modal.message({
                        title: content.successTitle[language],
                        text: `${content.successText[language]} ${name}!`,
                        icon: "success",
                        callback: () => {
                            setUnassignedSubscriptions(unassignedSubscriptions - 1);
                            auth.setavailableCoursesToAssignStoreSeen(0);
                            navigate(`/course/${course_id}`);
                        },
                    });
                    // setIsLoading(false);
                } else {
                    setIsLoading(false);
                }
            },
        });
    };

    const navigate = useNavigate();
    let location = useLocation();
    return (
        <>
            {!isObjectEmpty(course) && (
                <div className="w-full glassy smooth clr-text-primary shadow-large rounded-lg overflow-hidden">
                    <div className="p-4 space-y-8">
                        <div className="overflow-hidden rounded-md">
                            <img src={`${baseURL}/${course.picture}`} alt="course" />
                        </div>
                        {isSessionReservation && course.live_sessions_allowed > 0 && (
                            <Button
                                color="slate"
                                element="Link"
                                to="/session_reservation"
                                className="w-full inline-block text-center"
                            >
                                {content.sessionButton[language]}
                            </Button>
                        )}
                        {parseInt(course.price) === 0 ? (
                            <>
                                <Button color="rose" className="w-full inline-block text-center">
                                    {content.freeCourse[language]}
                                </Button>
                            </>
                        ) : (
                            <>
                                {token && course.subscriptions_count > 0 ? (
                                    <Button
                                        color="cyan"
                                        className="w-full inline-block text-center"
                                    >
                                        {content.alreadySubscribed[language]}
                                    </Button>
                                ) : (
                                    <div className="flex-center-both">
                                        {isUnassignedSubscription &&
                                        course.is_available_for_custom_assigned_subscription &&
                                        unassignedSubscriptions > 0 ? (
                                            <div className="bg-teal-500 rounded-full px-5 w-full py-4 text-center clr-white">
                                                {content.unassignedBalance[language]}
                                            </div>
                                        ) : isPrepaidSystem &&
                                          course.prepaidable &&
                                          prepaidCourses > 0 ? (
                                            <div className="bg-teal-500 rounded-full px-5 w-full py-4 text-center clr-white">
                                                {content.prepaidBalance[language]}
                                            </div>
                                        ) : (
                                            <CourseItemsCounter
                                                text={language === "ar" ? "جنيهًا" : "EGP"}
                                                number={course.price}
                                                isIncreasing={false}
                                                icon="ant-design:pound-circle-twotone"
                                                counterClassName="bg-blue-600"
                                                className="bg-yellow-500 text-slate-100 ml-0"
                                                iconClassName="text-yellow-400"
                                            />
                                        )}
                                    </div>
                                )}
                                {token && course.subscriptions_count < 1 ? (
                                    isUnassignedSubscription &&
                                    course.is_available_for_custom_assigned_subscription &&
                                    unassignedSubscriptions > 0 ? (
                                        <Button
                                            isLoading={isLoading}
                                            onClick={onAssignCourseClick}
                                            color="blue"
                                            className="w-full inline-block text-center"
                                        >
                                            {content.subscribeNow[language]}
                                        </Button>
                                    ) : isPrepaidSystem &&
                                      course.prepaidable &&
                                      prepaidCourses > 0 ? (
                                        <Button
                                            isLoading={isLoading}
                                            onClick={onPrepaidClick}
                                            color="blue"
                                            className="w-full inline-block text-center"
                                        >
                                            {content.subscribeNow[language]}
                                        </Button>
                                    ) : (
                                        <Button
                                            element="Link"
                                            to={`subscribe/previous_invoices/`}
                                            color="blue"
                                            className="w-full inline-block text-center"
                                        >
                                            {content.subscribeNow[language]}
                                        </Button>
                                    )
                                ) : (
                                    ""
                                )}
                                {!token && (
                                    <Button
                                        onClick={() => {
                                            modal.message({
                                                title: content.loginRequired.title[language],
                                                text: content.loginRequired.text[language],
                                                icon: "warning",
                                                button: content.loginRequired.button[language],
                                                callback: (accept) => {
                                                    if (accept) {
                                                        navigate("/login", {
                                                            state: { prevPath: location.pathname },
                                                        });
                                                    }
                                                },
                                            });
                                        }}
                                        color="blue"
                                        className="w-full inline-block text-center"
                                    >
                                        {content.subscribeNow[language]}
                                    </Button>
                                )}
                            </>
                        )}
                        <div className="font-small">
                            {!course.is_disabled_counts ? (
                                <>
                                    {/* <CourseDescItem
                                        title="المحتوى"
                                        value={`+ ${course.total_videos_duration}`}
                                        valueName={
                                            course.total_videos_duration <= 10 &&
                                            course.total_videos_duration !== 1
                                                ? "ساعات"
                                                : "ساعة"
                                        }
                                        icon="icon-park-twotone:time"
                                    /> */}
                                    <CourseDescItem
                                        title={content.totalQuestions[language]}
                                        value={`+ ${course.total_questions_quantity}`}
                                        valueName={`${
                                            course.total_questions_quantity <= 10 &&
                                            course.total_questions_quantity !== 1
                                                ? language === "ar"
                                                    ? "أسئلة"
                                                    : language === "de"
                                                    ? "Fragen"
                                                    : "Questions"
                                                : language === "ar"
                                                ? "سؤال"
                                                : language === "de"
                                                ? "Frage"
                                                : "Question"
                                        }`}
                                        icon="ant-design:question-circle-twotone"
                                        isLast={true}
                                    />
                                </>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CourseInfoSection;
